import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram, Facebook, MapPin } from 'lucide-react';

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo/Name */}
          <div className="mb-4 md:mb-0">
            <h2 className="text-xl font-bold">AEM Family</h2>
          </div>
          
          {/* Essential Links */}
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
              Contact
            </Link>
            <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">
              Politique de confidentialité
            </Link>
            <Link to="/faqs" className="text-gray-300 hover:text-white transition-colors">
              À propos
            </Link>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-6 pt-4 border-t border-gray-800 text-center text-sm text-gray-400">
          &copy; {new Date().getFullYear()} AEM Marketplace. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
}